export const checkRegister24HoursAgo = (createdAt: string) => {
  const now = new Date()

  const createdAtTime = new Date(createdAt).getTime()
  const twentyFourHoursAgo = now.getTime() - 24 * 60 * 60 * 1000

  return createdAtTime >= twentyFourHoursAgo
}
